<ul>
  <li
    *ngFor="let client of clients"
    (click)="switchClient(client)"
    [ngClass]="{ active: activeClient(client) }"
  >
    <img src="{{ channelIcon(client.provider) }}" /> {{ client.provider }}
  </li>
</ul>
